import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useToast } from '@/hooks/use-toast'
import { adminApi } from './api'
import { handleApiError } from '@/lib/api/axios'

export function usePopulatePermissions() {
    const { toast } = useToast()
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: () => adminApi.populatePermissions(),
        onSuccess: (response) => {
            const data = response.data.data
            // Invalidate permissions cache so UI refreshes with new permissions
            queryClient.invalidateQueries({ queryKey: ['roles', 'permissions'] })
            queryClient.invalidateQueries({ queryKey: ['permissions'] })
            toast({
                title: 'Permissions Populated',
                description: `Created ${data.permissionsCreated} permissions, assigned ${data.roleLinksCreated} role-permission links.`,
            })
        },
        onError: (error) => {
            toast({
                title: 'Error',
                description: handleApiError(error),
                variant: 'destructive',
            })
        },
    })
}
